import { Paper, Skeleton, Stack } from "@mui/material";
import { V2DisplayOnlyField as DisplayOnlyField } from "routes/Customer/Facility/ProfileV2/V2DisplayOnlyField";

import { useFrozenSnapshotContent } from "./frozenSnapshot";
import { formatReasonForSubmittal } from "./reasonForSubmittalLabels";
import { StepSubHeader } from "./StepSubHeader";

/**
 * Read-only Submission Details for a frozen (filed) submission, mirroring the
 * editable `DetailsCard` but sourced from the `RCRA_8700_12` snapshot rather than
 * the live submission — so it shows exactly what was filed. Surfaces the two
 * submission-level 8700-12 form fields the snapshot carries: §1 Reason for
 * Submittal and §18 Public Comments (the submission's notes at freeze time).
 */
export function FrozenDetailsPanel({ submissionId }: { submissionId: string }) {
  const { resolved, loading, content } = useFrozenSnapshotContent(submissionId);

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <StepSubHeader title="Details" />
        {loading && !content ? (
          <Skeleton variant="rounded" height={80} />
        ) : (
          <Stack spacing={2} sx={{ maxWidth: 760 }}>
            <DisplayOnlyField
              label="Reason for Submittal (§1)"
              text={formatReasonForSubmittal(resolved?.reasonForSubmittal)}
            />
            <DisplayOnlyField
              label="Public Comments (§18)"
              text={resolved?.rcraProfile?.publicComments ?? ""}
            />
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}
